import { render } from "./NavDots.vue?vue&type=template&id=6e03d0a6"
import script from "./NavDots.vue?vue&type=script&lang=js"
export * from "./NavDots.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__